
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rims/pickup",
      function () {
        return require("private-next-pages/rims/pickup.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rims/pickup"])
      });
    }
  